/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
    if (
      document.querySelectorAll(".radio__button-variant-option-special").length > 0
    ) {
        // build accordion
        const radio_accordion_wrapper = document.createElement(
            "collapsible-elements"
        );
        radio_accordion_wrapper.setAttribute("single", true);
        let radio_accordion_child_1 = document.createElement("div");
        radio_accordion_child_1.classList.add("product-accordion");
        let radio_accordion_child_1_1 = document.createElement("details");
        radio_accordion_child_1_1.classList.add("accordion");
        radio_accordion_child_1_1.setAttribute("data-collapsible", "");
        radio_accordion_child_1_1.id = "other-sizes";
        let radio_accordion_child_1_1_1 = document.createElement("summary");
        radio_accordion_child_1_1_1.classList.add("accordion__title");
        radio_accordion_child_1_1_1.setAttribute("data-collapsible-trigger", "");
        let radio_accordion_child_1_1_1_1 =
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        let radio_accordion_child_1_1_1_2 =
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 24 24"><path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        radio_accordion_child_1_1_1.innerHTML =
            radio_accordion_child_1_1_1_1 +
            radio_accordion_child_1_1_1_2 +
            document.getElementById("other_sizes_label").textContent;
        let radio_accordion_child_1_1_2 = document.createElement("div");
        radio_accordion_child_1_1_2.classList.add("accordion__body");
        radio_accordion_child_1_1_2.classList.add("rte");
        radio_accordion_child_1_1_2.setAttribute("data-collapsible-body", "");
        const params = new URLSearchParams(window.location.search);
        if (params.get("accordion") === "other-sizes") {
            radio_accordion_child_1_1.setAttribute("open", "true");
            radio_accordion_child_1_1_2.style.height = "auto";
        }
        let radio_accordion_child_1_1_2_1 = document.createElement("div");
        radio_accordion_child_1_1_2_1.classList.add("accordion__subtitle");
        radio_accordion_child_1_1_2_1.classList.add("body-size-2");
        let radio_accordion_child_1_1_2_2 = document.createElement("div");
        radio_accordion_child_1_1_2_2.classList.add("accordion__content");
        radio_accordion_child_1_1_2_2.setAttribute("data-collapsible-content", "");
        let radio_accordion_child_1_1_2_1_1 =
            document.createElement("toggle-ellipsis");
        radio_accordion_child_1_1_2_1_1.setAttribute("data-height", "1200");
        radio_accordion_child_1_1_2_1_1.classList.add("is-open");
        let radio_accordion_child_1_1_2_1_1_1 = document.createElement("div");
        radio_accordion_child_1_1_2_1_1_1.classList.add("toggle-ellipsis__content");
        radio_accordion_child_1_1_2_1_1_1.setAttribute("data-content", "");
        let radio_accordion_child_1_1_2_1_1_2 = document.createElement("div");
        radio_accordion_child_1_1_2_1_1_2.classList.add("toggle-ellipsis__actions");
        radio_accordion_child_1_1_2_1_1_2.setAttribute("data-actions", "");
        let radio_accordion_child_1_1_2_1_1_2_1 = document.createElement("button");
        radio_accordion_child_1_1_2_1_1_2_1.setAttribute("type", "button");
        radio_accordion_child_1_1_2_1_1_2_1.classList.add("caps--link");
        radio_accordion_child_1_1_2_1_1_2_1.setAttribute("data-button", "");
        radio_accordion_child_1_1_2_1_1_2_1.innerHTML =
            "<span>" +
            document.getElementById("show_more_label").textContent +
            "</span>";

        radio_accordion_child_1_1_2_1_1_2.appendChild(
            radio_accordion_child_1_1_2_1_1_2_1
        );
        radio_accordion_child_1_1_2_1_1.appendChild(
            radio_accordion_child_1_1_2_1_1_1
        );
        radio_accordion_child_1_1_2_1_1.appendChild(
            radio_accordion_child_1_1_2_1_1_2
        );
        radio_accordion_child_1_1_2_2.appendChild(radio_accordion_child_1_1_2_1_1);
        radio_accordion_child_1_1_2.appendChild(radio_accordion_child_1_1_2_1);
        radio_accordion_child_1_1_2.appendChild(radio_accordion_child_1_1_2_2);
        radio_accordion_child_1_1.appendChild(radio_accordion_child_1_1_1);
        radio_accordion_child_1_1.appendChild(radio_accordion_child_1_1_2);
        radio_accordion_child_1.appendChild(radio_accordion_child_1_1);
        radio_accordion_wrapper.appendChild(radio_accordion_child_1);

        document
            .querySelectorAll(".radio__button-variant-option-special")
            .forEach((variant_option_special) =>
                radio_accordion_child_1_1_2_1_1_1.appendChild(variant_option_special)
            );
        document.querySelector(
            ".radio__fieldset--variant-option-size .radio__buttons"
        ).innerHTML =
            document.querySelector(
                ".radio__fieldset--variant-option-size .radio__buttons"
            ).innerHTML + radio_accordion_wrapper.outerHTML;

        // open accordion if the special variant already selected
        // COMENTADO: Ahora el acordeón siempre está cerrado por defecto
        // setTimeout(function () {
        //     if (
        //         document.querySelectorAll(
        //             ".radio__button-variant-option-special input[checked]"
        //         ).length > 0
        //     ) {
        //         document
        //             .querySelector(".radio__fieldset--variant-option-size summary")
        //             .click();
        //         document
        //             .querySelector(".radio__fieldset--variant-option-size [data-button]")
        //             .click();
        //         
        //         // Show the special delivery message for the already selected variant
        //         const checkedSpecialInput = document.querySelector(".radio__button-variant-option-special input[checked]");
        //         if (checkedSpecialInput) {
        //             const variantButton = checkedSpecialInput.closest('.radio__button');
        //             const accordionSubtitle = variantButton.getAttribute('data-accordion-subtitle');
        //             const shippingLabel = variantButton.getAttribute('data-shipping-label');
        //             
        //             ('Special variant already selected on page load');
        //             showShippingLabelTruck(shippingLabel, accordionSubtitle);
        //         }
        //     }
        // });

    
        function updateAccordionSubtitle(selectedInput) {
            const accordionSubtitle = document.querySelector('.accordion__subtitle');
            if (!accordionSubtitle) return;
            const isInsideAccordion = selectedInput.closest('.accordion__content');
            const variantButton = selectedInput.closest('.radio__button');
            const isSpecial = variantButton && variantButton.classList.contains('radio__button-variant-option-special');

            if (!isInsideAccordion || !isSpecial) {
                accordionSubtitle.classList.remove('visible');
                setTimeout(() => { accordionSubtitle.textContent = ''; }, 300);
                return;
            }

            const text = variantButton.getAttribute('data-accordion-subtitle') || '';
            const iconType = variantButton.getAttribute('data-icon');
            let iconHTML = '';
            if (iconType === 'clock') {
                iconHTML = `<svg class="icon-clock" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20z"></path>
                                <path d="M12 6v6l4 2"></path>
                                </svg>`;
            }
            accordionSubtitle.innerHTML = `${iconHTML}<span>${text}</span>`;
            accordionSubtitle.classList.add('visible');
        }

        function initVariantChangeListener() {
            document.addEventListener('change', function(e) {
                if (!e.target.matches('input[data-single-option-selector]')) return;

                updateAccordionSubtitle(e.target);
            });
        }

        function checkInitialSpecialVariant() {
            const selectedInput = document.querySelector(
                '.accordion__content input[data-single-option-selector]:checked'
            );

            if (selectedInput) {
                updateAccordionSubtitle(selectedInput);
            }
        };

        initVariantChangeListener();
        checkInitialSpecialVariant();

    } 


    /* Save customization_text field for products */
    const required_fields = []

    // handle custom text input
    const customization_text_input =
        document.getElementById("customization_text");
    if (null !== customization_text_input) {
        if(customization_text_input.getAttribute('required') !== null) required_fields.push('customization_text_hidden')

        // add hidden input to the product-form
        let hidden_input = document.createElement("input");
        hidden_input.setAttribute("type", "hidden");
        hidden_input.setAttribute(
        "name",
        'properties[' + customization_text_input.getAttribute("data-name") + ']'
        );
        hidden_input.setAttribute("value", "");
        hidden_input.setAttribute("id", "customization_text_hidden");
        document.querySelector("form.product-form").appendChild(hidden_input);

        customization_text_input.addEventListener("input", function () {
        this.classList.remove('input-error');

        let value = this.value.toLowerCase();
        const mayusRadio = document.getElementById("initial_mayus");
        if (mayusRadio && mayusRadio.checked && value.length > 0) {
            value = value.charAt(0).toUpperCase() + value.slice(1);
        }

        this.value = value;
        document.getElementById("customization_text_hidden").setAttribute("value", value);

        if (value === '' && customization_text_input.getAttribute('required') !== null) {
            this.classList.add('input-error');
        }
        });

        const radios = document.querySelectorAll('input[name="primera_letra_visible"]');

        if (radios.length > 0) {
        const form = document.querySelector("form.product-form");

        if (form) {
            const hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = 'properties[' + radios[0].getAttribute("data-name") + ']';
            hiddenInput.value = document.querySelector('input[name="primera_letra_visible"]:checked')?.value || '';
            hiddenInput.id = "inicial_hidden";

            form.appendChild(hiddenInput);

            radios.forEach((radio) => {
            radio.addEventListener("change", function () {
                hiddenInput.value = this.value;
                customization_text_input.dispatchEvent(new Event('input'));
            });
            });
        }
        }

        // handle custom text length by numbers
        let letter_selector = document.querySelector('[data-product-variants] .radio__legend__option-name');
        if(null !== letter_selector && letter_selector.textContent === document.getElementById('letter_variant_text_identifier').value)
        {
            let radio_buttons = letter_selector.parentElement.parentElement.nextElementSibling;
            if(radio_buttons.classList.contains('radio__buttons'))
            {
                radio_buttons.childNodes.forEach((element) => {
                    if(undefined !== element.classList && element.classList.contains('radio__button'))
                    {
                        // check already selected variants
                        for(let i = 0; i < element.children.length; i++){
                            if (element.children[i].tagName === "INPUT" && element.children[i].checked) {
                                customization_text_input.setAttribute('maxlength', element.children[i].value)
                            }
                        }
                        
                        element.addEventListener("click", (event) => {
                            customization_text_input.value = ""
                            document.getElementById('customization_text_hidden').value = ""

                            for(let i = 0; i < element.children.length; i++){
                                if (element.children[i].tagName === "INPUT") {
                                    customization_text_input.setAttribute('maxlength', element.children[i].value)
                                }
                            }
                        })
                    }
                })
            }
        }
    }

    /* Save Chain color selects fields for products */
    // handle chain gold color select
    const chain_color_select_chain =
        document.getElementById("chain-color-select-chain");
    if (null !== chain_color_select_chain) {
        required_fields.push('chain_color_select_chain_hidden')

        let hidden_input_chain = document.createElement("input");
        hidden_input_chain.setAttribute("type", "hidden");
        hidden_input_chain.setAttribute(
            "name",
            'properties[' + chain_color_select_chain.getAttribute("data-name") + ']'
        );
        hidden_input_chain.setAttribute("value", "");
        hidden_input_chain.setAttribute("id", "chain_color_select_chain_hidden");
        hidden_input_chain.setAttribute("data-popout-input", "");
        document.querySelector("form.product-form").appendChild(hidden_input_chain);

        let chain_color_options = document.querySelectorAll('#chain-color-select-chain [data-popout-option]')
        for (let i = 0; i < chain_color_options.length; i++) {
            chain_color_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("chain_color_select_chain_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    // handle letter gold select
    const chain_color_select_letter =
        document.getElementById("chain-color-select-letter");
    if (null !== chain_color_select_letter) {
        required_fields.push('chain_color_select_letter_hidden')

        let hidden_input_letter = document.createElement("input");
        hidden_input_letter.setAttribute("type", "hidden");
        hidden_input_letter.setAttribute(
            "name",
            'properties[' + chain_color_select_letter.getAttribute("data-name") + ']'
        );
        hidden_input_letter.setAttribute("value", "");
        hidden_input_letter.setAttribute("data-popout-input", "");
        hidden_input_letter.setAttribute("id", "chain_color_select_letter_hidden");
        document.querySelector("form.product-form").appendChild(hidden_input_letter);

        let letter_color_options = document.querySelectorAll('#chain-color-select-letter [data-popout-option]')
        for (let i = 0; i < letter_color_options.length; i++) {
            letter_color_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("chain_color_select_letter_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    /* Save Single letter selects field for products */
    const single_letter_select =
        document.getElementById("single-letter-select");
    if (null !== single_letter_select) {
        required_fields.push('single_letter_select_hidden')

        let hidden_input_letter = document.createElement("input");
        hidden_input_letter.setAttribute("type", "hidden");
        hidden_input_letter.setAttribute(
            "name",
            'properties[' + single_letter_select.getAttribute("data-name") + ']'
        );
        hidden_input_letter.setAttribute("value", "");
        hidden_input_letter.setAttribute("id", "single_letter_select_hidden");
        hidden_input_letter.setAttribute("data-popout-input", "");
        document.querySelector("form.product-form").appendChild(hidden_input_letter);

        let single_letter_options = document.querySelectorAll('#single-letter-select [data-popout-option]')
        for (let i = 0; i < single_letter_options.length; i++) {
            single_letter_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("single_letter_select_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    /* Save Double letter selects fields for products */
    // handle upper letter select
    const double_letter_select_upper =
        document.getElementById("double-letter-select-upper");
    if (null !== double_letter_select_upper) {
        required_fields.push('double_letter_select_upper_hidden')

        let hidden_input_upper = document.createElement("input");
        hidden_input_upper.setAttribute("type", "hidden");
        hidden_input_upper.setAttribute(
            "name",
            'properties[' + double_letter_select_upper.getAttribute("data-name") + ']'
        );
        hidden_input_upper.setAttribute("value", "");
        hidden_input_upper.setAttribute("id", "double_letter_select_upper_hidden");
        hidden_input_upper.setAttribute("data-popout-input", "");
        document.querySelector("form.product-form").appendChild(hidden_input_upper);

        let upper_letter_options = document.querySelectorAll('#double-letter-select-upper [data-popout-option]')
        for (let i = 0; i < upper_letter_options.length; i++) {
            upper_letter_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("double_letter_select_upper_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    // handle letter gold select
    const double_letter_select_bottom =
        document.getElementById("double-letter-select-bottom");
    if (null !== double_letter_select_bottom) {
        required_fields.push('double_letter_select_bottom_hidden')

        let hidden_input_bottom = document.createElement("input");
        hidden_input_bottom.setAttribute("type", "hidden");
        hidden_input_bottom.setAttribute(
            "name",
            'properties[' + double_letter_select_bottom.getAttribute("data-name") + ']'
        );
        hidden_input_bottom.setAttribute("value", "");
        hidden_input_bottom.setAttribute("data-popout-input", "");
        hidden_input_bottom.setAttribute("id", "double_letter_select_bottom_hidden");
        document.querySelector("form.product-form").appendChild(hidden_input_bottom);

        let bottom_letter_options = document.querySelectorAll('#double-letter-select-bottom [data-popout-option]')
        for (let i = 0; i < bottom_letter_options.length; i++) {
            bottom_letter_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("double_letter_select_bottom_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    // validate required custom fields
    function validateRequiredFields() {
        let valid = true

        required_fields.forEach(node =>{
            if(document.getElementById(node) === null ||
                (document.getElementById(node) !== null && document.getElementById(node).value === '' || document.getElementById(node).value === null)){
                valid = false
                document.querySelector('[data-hidden-input="' + node + '"]').classList.add('input-error')
            }
        })

        return valid
    }
    if(required_fields.length > 0){
        document.addEventListener('theme:cart:add', event => {
            if(!validateRequiredFields()){
                event.stopImmediatePropagation()
            }
        })
    }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
